// ============================================================================
// CANCUN100 — Frases motivacionales para el popup de bienvenida del agente.
// Tono cálido, sin clichés gastados ni autores dudosos. Mezcla de ventas,
// actitud, persistencia, equipo y sabor Cancún/playa.
// ============================================================================
// Frases del resumen PDF del agente (dosFrasesResumen en App.js).
const FRASES_MOTIVACIONALES = [
  // — Ventas —
  'Cada cliente es una historia que empieza contigo.',
  'No vendes tours, vendes recuerdos que van a durar toda la vida.',
  'Escucha el doble de lo que hablas y venderás el triple.',
  'La mejor venta es la que deja al cliente contando su viaje a los demás.',
  'Un “no” de hoy es solo un “todavía no”; sigue.',
  'Conoce tu producto tan bien que recomendarlo se sienta como un favor.',
  'El precio se olvida, la experiencia que prometes se recuerda.',
  'Vender es ayudar a alguien a decidir lo que ya quería.',
  'La confianza se cierra antes que la venta.',
  'Tu entusiasmo es contagioso: úsalo a favor del cliente.',
  'Detrás de cada folio hay una familia esperando su mejor día.',
  'Responde rápido: la duda del cliente tiene fecha de caducidad.',
  'Haz una pregunta más de las que crees necesarias; ahí está la venta.',
  'Cierra con calma: la prisa asusta, la seguridad convence.',
  'El seguimiento es donde los buenos vendedores se vuelven grandes.',

  // — Actitud —
  'Empieza el día decidiendo cómo te va a ir.',
  'Tu energía entra a la sala antes que tú.',
  'Sonríe: se nota hasta por teléfono.',
  'Lo que repites cada mañana, te termina definiendo.',
  'Elige tu actitud; es lo único que nadie te puede quitar.',
  'Un buen ánimo no cambia el clima, pero cambia tu día completo.',
  'Trata cada llamada como si fuera la primera, no la número veinte.',
  'La calma también vende: transmite paz y cerrarás más.',
  'Hoy es un gran día para superar tu marca de ayer.',
  'La actitud correcta convierte un problema en un “déjame ayudarte”.',
  'Ponle corazón a lo aburrido y hasta el papeleo rinde.',
  'Cuida los detalles pequeños; ahí vive la diferencia.',

  // — Persistencia —
  'La constancia le gana al talento cuando el talento se relaja.',
  'Los resultados llegan tarde, pero llegan a quien insiste.',
  'Un paso hoy vale más que un plan perfecto para mañana.',
  'Cae siete veces, levántate ocho, cierra a la novena.',
  'La meta no se corre en un día; se camina todos los días.',
  'Cuando quieras rendirte, recuerda por qué empezaste.',
  'El esfuerzo de hoy es el ingreso de fin de mes.',
  'Nadie ve tus horas difíciles, todos verán tus resultados.',
  'Sigue tocando puertas: la tuya está por abrirse.',
  'La disciplina es hacerlo también los días sin ganas.',
  'Poco a poco se llega lejos; deprisa se llega cansado.',
  'Lo que hoy te cuesta, mañana lo harás sin pensar.',

  // — Equipo —
  'Solos vamos rápido, en equipo llegamos lejos.',
  'Comparte lo que aprendes: el equipo que enseña, crece.',
  'Un buen compañero vale más que un buen día de suerte.',
  'Celebra las ventas de al lado como si fueran tuyas.',
  'Pregunta sin miedo; nadie nació sabiendo cerrar.',
  'El mérito del equipo empieza con tu honestidad.',
  'Cubrir a un compañero hoy es tener quién te cubra mañana.',
  'Las mejores ideas nacen cuando el equipo confía.',
  'Suma, no compitas: el pastel crece para todos.',
  'Tu buen ejemplo enseña más que mil instrucciones.',

  // — Cancún / playa —
  'Vendes el Caribe: pon un poco de sol en cada mensaje.',
  'El mar no se apura y siempre llega; tú también.',
  'Cada amanecer en Cancún es una razón más para empezar bien.',
  'Trabaja con la calma del mar y la constancia de la marea.',
  'Regálale a tu cliente el Caribe antes de que llegue a la playa.',
  'Como la arena, deja huella buena por donde pases.',
  'La brisa cambia, tú mantén el rumbo.',
  'Hoy vendes paraíso; hazlo sonar como tal.',
  'La ola perfecta llega a quien sigue remando.',
  'Ponle ritmo de playa al día y hasta el cansancio se siente distinto.',

  // — Cierre / valor —
  'Tu trabajo mueve la economía de tu familia y de tu ciudad.',
  'Cada folio bien hecho es una promesa que sí se cumple.',
  'Haz las cosas bien aunque nadie mire; tú sí te ves.',
  'Aprende algo nuevo cada semana y serás imparable en un año.',
  'El cliente contento regresa y trae a tres más.',
  'Hoy puede ser el día de tu mejor venta del mes.',

  // — Ventas (más) —
  'El cliente compra tu seguridad antes que tu tour.',
  'Una buena pregunta abre más puertas que mil argumentos.',
  'Vende beneficios, no características: la gente compra lo que siente.',
  'Si tú no crees en el tour, el cliente tampoco.',
  'Pon el precio con firmeza y sonrisa; dudar te delata.',
  'Cada objeción es una pista de lo que le importa.',
  'No persigas la venta, guía la decisión.',
  'El que da opciones claras, cierra sin presionar.',
  'Anota lo que el cliente ama y véndele exactamente eso.',
  'Un mensaje a tiempo vale más que diez tardíos.',
  'Habla de la experiencia, no del itinerario.',
  'La venta empieza cuando el cliente deja de dudar de ti.',
  'Repite el nombre del cliente: se siente en casa.',
  'Ofrece de más solo si suma al viaje, no a tu comisión.',
  'El silencio también negocia; deja que el cliente piense.',
  'Nadie compra apurado; compra convencido.',
  'Un detalle recordado hoy cierra la venta de mañana.',
  'Conoce tres tours a fondo antes que treinta a medias.',
  'La primera impresión se cobra en confianza.',
  'Vende como si recomendaras a un amigo, porque eso haces.',
  'El cliente indeciso necesita claridad, no descuentos.',
  'Cierra preguntando, no rogando.',
  'Tu tono dice más que tus palabras: cuídalo.',
  'Prometer poco y cumplir mucho crea clientes de por vida.',
  'La venta bien atendida se recomienda sola.',
  'Escucha la necesidad real detrás de la pregunta.',
  'Deja que el cliente se imagine ya en la playa.',
  'Un “déjame checarlo” bien resuelto salva la venta.',
  'Vender con calma también es vender con clase.',
  'El catálogo lo sabes; el cliente quiere sentirlo.',

  // — Esfuerzo / disciplina —
  'El talento abre la puerta; la disciplina te mantiene adentro.',
  'Hazlo cansado, hazlo con sueño, pero hazlo.',
  'Los días grises también cuentan para tu meta.',
  'Levántate una vez más que las veces que caíste.',
  'Lo difícil de hoy es tu ventaja de mañana.',
  'Suma pequeños esfuerzos y verás grandes números.',
  'No cuentes las horas; haz que las horas cuenten.',
  'La rutina bien hecha es tu mejor aliada.',
  'Empieza aunque no tengas ganas; las ganas llegan después.',
  'El que insiste con orden, avanza sin agotarse.',
  'Un poco cada día vence a mucho de vez en cuando.',
  'Tu esfuerzo callado hablará por ti en la quincena.',
  'Nadie madruga en balde cuando sabe a dónde va.',
  'Termina lo que empiezas; ahí se forja tu palabra.',
  'La constancia no se ve, pero se cobra.',
  'Trabaja hoy por el descanso que quieres mañana.',
  'El esfuerzo no se negocia; se acumula.',
  'Cada tarea bien cerrada es un ladrillo de tu futuro.',
  'Cuando otros aflojan, tú aprietas: ahí se gana.',
  'La meta se acerca con cada paso, no con cada deseo.',
  'Suda hoy para brillar mañana.',
  'El orden de tu día ordena tus resultados.',
  'No busques atajos; busca ritmo.',
  'Persiste con cabeza fría y corazón caliente.',
  'Lo que hoy te exige, mañana te sostiene.',
  'El reloj corre igual para todos; úsalo mejor.',
  'Cada esfuerzo extra deja huella en tu bolsillo.',
  'La disciplina es amor propio en acción.',

  // — Familia —
  'Trabajas por quienes te esperan en casa; eso vale oro.',
  'Cada venta pone un plato más en tu mesa.',
  'Tu esfuerzo hoy es el orgullo de tu familia mañana.',
  'Ganas por los tuyos: no hay motivo más fuerte.',
  'Un buen día tuyo es tranquilidad para tu hogar.',
  'Lo que construyes aquí, lo disfrutan en casa.',
  'Tu familia no ve el cansancio, ve el ejemplo.',
  'Cierra ventas pensando en quién te motiva; se nota.',
  'El mejor regalo para los tuyos es tu constancia.',
  'Cada meta cumplida es una promesa a tu familia.',
  'Trabaja con cariño; en casa se recibe como amor.',
  'Tus hijos aprenden más de tus hábitos que de tus consejos.',
  'La quincena se disfruta más cuando la ganaste con orgullo.',
  'Detrás de tu esfuerzo hay una familia que cree en ti.',
  'Ganar bien es cuidar a los que amas.',
  'Hoy sales por ellos; que se sienta en tu ánimo.',
  'Tu trabajo sostiene sueños que no son solo tuyos.',
  'Cada logro tuyo se celebra dos veces en casa.',
  'El sacrificio de hoy es el techo firme de los tuyos.',
  'Vuelve a casa sabiendo que diste lo mejor.',
  'Tu familia es tu razón; que sea también tu fuerza.',
  'Los buenos días de trabajo se sienten en la sobremesa.',
  'Ganas tu pan con dignidad; eso enseña más que mil palabras.',
  'Que tu esfuerzo hable de cuánto quieres a los tuyos.',
  'Cada cliente atendido con amor honra a tu familia.',
  'El orgullo de tu gente empieza con tu constancia.',
  'Trabaja para dar, no solo para tener.',
  'Lo que ganas con esfuerzo, en casa rinde el doble.',

  // — Orgullo del trabajo —
  'Firma cada folio como quien firma su nombre con honor.',
  'Haz bien hasta lo que nadie revisa.',
  'Tu trabajo es tu firma; que hable bien de ti.',
  'Ponle orgullo a la tarea más pequeña.',
  'El trabajo bien hecho no necesita presumirse.',
  'Sé de los que dejan todo mejor de como lo encontraron.',
  'La calidad de tu trabajo dice quién eres.',
  'Un oficio con orgullo nunca es poca cosa.',
  'Trabaja para estar orgulloso al mirarte al espejo.',
  'El que cuida su trabajo, se cuida a sí mismo.',
  'Hazlo con esmero: tu nombre viaja en cada venta.',
  'No hay tarea humilde cuando le pones el alma.',
  'Deja huella de profesional en todo lo que toques.',
  'Tu reputación se construye con cada detalle.',
  'El respeto se gana haciendo bien lo tuyo.',
  'Ama tu oficio y él te devolverá el favor.',
  'Sé mejor hoy que ayer, aunque sea un poco.',
  'El orgullo sano empuja a hacerlo excelente.',
  'Que tu trabajo sea la mejor carta de presentación.',
  'Lo bien hecho se nota mucho después de la venta.',
  'Cada cliente bien atendido es tu medalla del día.',
  'Trabaja como si tu nombre estuviera en la puerta.',
  'La excelencia es un hábito, no un golpe de suerte.',
  'Honra tu palabra: es tu mejor capital.',
  'El que hace bien lo pequeño, merece lo grande.',
  'Tu esfuerzo tiene valor aunque el día parezca gris.',
  'Enorgullécete del camino, no solo de la meta.',
  'Ser bueno en lo tuyo es una forma de dignidad.',

  // — Cerrar ventas —
  'Cerrar es ayudar a decidir, no empujar a firmar.',
  'Pregunta “¿lo aparto?” con naturalidad y verás magia.',
  'El cierre llega cuando el cliente ya se ve viajando.',
  'No temas al “sí”; guíalo con calma.',
  'Un buen cierre se siente como un alivio, no como presión.',
  'Resume beneficios y ofrece el siguiente paso.',
  'Quien resuelve la última duda, cierra la venta.',
  'El cierre empieza desde tu primer saludo.',
  'Dale al cliente una razón para decidir hoy.',
  'Cierra con seguridad; la duda tuya contagia la suya.',
  'Ofrece cerrar, no solo informar.',
  'El “déjame pensarlo” se responde con más claridad, no más precio.',
  'Acompaña la decisión hasta el final; ahí se gana.',
  'Un cierre firme y amable vale por diez folletos.',
  'Cuando todo está claro, solo falta que preguntes.',
  'El mejor cierre deja al cliente sintiéndose inteligente.',
  'No dejes la venta a medias: da el último paso.',
  'Cierra hoy lo que hoy se puede cerrar.',
  'La venta se cae en el silencio que no aprovechaste.',
  'Confirma, agenda y agradece: así se cierra bonito.',
  'Un cierre claro evita mil arrepentimientos.',
  'Si el cliente está listo, no lo hagas esperar.',
  'Cierra como quien invita, no como quien cobra.',
  'El seguimiento convierte “casi” en “hecho”.',
  'Nada cierra mejor que un cliente que confía.',
  'Pon fácil el sí y difícil el arrepentimiento.',
  'El cierre es servicio, no victoria personal.',
  'Cada duda resuelta te acerca a la firma.',

  // — Servicio al cliente —
  'Atiende como te gustaría que atendieran a tu mamá.',
  'Un cliente bien tratado perdona hasta un error.',
  'Responde con ganas: se siente del otro lado.',
  'Resuelve rápido y explica con paciencia.',
  'El buen trato es gratis y vale muchísimo.',
  'Haz que cada cliente se sienta el único del día.',
  'Un “con gusto” sincero abre corazones y carteras.',
  'Cumple lo que prometes, aunque cueste.',
  'El cliente recuerda cómo lo hiciste sentir.',
  'Escuchar bien ya es medio problema resuelto.',
  'Trata cada mensaje como una persona, no un número.',
  'La amabilidad es tu mejor herramienta de ventas.',
  'Da un poquito más de lo que esperan.',
  'Un cliente feliz es tu mejor publicidad.',
  'Pide disculpas rápido y soluciona más rápido.',
  'El servicio empieza cuando dejas de pensar en la comisión.',
  'Sé claro, sé humano, sé rápido.',
  'Acompaña al cliente, no solo lo despaches.',
  'Un detalle amable hoy es un cliente fiel mañana.',
  'Sonríe al escribir; el tono cambia todo.',
  'Atiende la duda pequeña con la misma calidez que la grande.',
  'La cortesía nunca está de más ni de moda.',
  'El cliente no interrumpe tu trabajo: es tu trabajo.',
  'Cuida el después de la venta como el antes.',
  'Regala tranquilidad y venderás confianza.',
  'Un gracias sincero cierra el círculo del buen servicio.',
  'Haz sencillo lo complicado y el cliente te lo agradecerá.',
  'Cada llamada es una oportunidad de dejar huella buena.',
  'Sirve con el corazón y el número llegará solo.',
  'La paciencia también es una forma de vender.',

  // — Ambición sana —
  'Sueña en grande y trabaja en concreto.',
  'Querer más está bien cuando das más.',
  'Ponte metas que te hagan crecer, no que te asusten.',
  'La ambición sana empuja; la envidia estanca.',
  'Compite contigo: ayer es tu único rival justo.',
  'Aspira alto y prepárate para sostenerlo.',
  'El techo de hoy es el piso de mañana.',
  'No te conformes con menos de lo que puedes dar.',
  'Quiere ganar bien y merécelo trabajando mejor.',
  'Tus metas grandes empiezan con hábitos pequeños.',
  'Apunta lejos, pero da el paso de hoy.',
  'El que se supera no le quita a nadie; suma.',
  'Crece sin dejar de ser buena persona.',
  'La mejor versión tuya aún no ha vendido su récord.',
  'Ambiciona resultados, cuida tus formas.',
  'Ganar más para dar más: esa es la ambición bonita.',
  'Sube un escalón hoy y no lo sueltes.',
  'Que tu meta te ilusione, no que te presione.',
  'El progreso se disfruta cuando lo ganaste con honor.',
  'Piensa en grande, actúa en pequeño, avanza siempre.',
  'Tu potencial es más grande que tu mejor mes.',
  'Reta tu récord con respeto por tu esfuerzo.',
  'Quien crece con humildad, llega más lejos.',
  'La ambición con valores construye; sin ellos, derriba.',
  'Ponle nombre y fecha a tu próxima meta.',
  'Merecer se construye; no se exige.',

  // — Equipo (más) —
  'El equipo que se apoya, vende más tranquilo.',
  'Levanta al de al lado y subes tú también.',
  'Comparte un buen tip; regresa multiplicado.',
  'Un “yo te cubro” hoy vale por mil discursos.',
  'Las metas del equipo se cargan entre todos.',
  'Aplaude fuerte las ventas ajenas.',
  'Nadie brilla solo en una sala que apaga a los demás.',
  'Enseña sin recelo; el que enseña, domina.',
  'Tu buena onda mejora el día de todo el equipo.',
  'Juntos se aguantan los días difíciles.',
  'Pregunta, ayuda, agradece: así se hace equipo.',
  'La confianza del equipo se cuida con hechos.',
  'Reconoce al compañero; el reconocimiento une.',
  'El equipo gana cuando cada uno da su parte.',
  'Comparte la carga y compartirán tu triunfo.',
  'Un buen ambiente vende más que mil promociones.',
  'Cuida al nuevo: alguien te cuidó a ti.',
  'La competencia sana empuja; la sucia hunde a todos.',
  'Suma manos y multiplicarás metas.',
  'Un equipo unido convierte problemas en soluciones.',
  'Da crédito a quien ayudó; volverá a ayudarte.',
  'El respeto entre compañeros es la base de todo.',
  'Celebrar juntos hace más ligero el esfuerzo.',
  'El que jala parejo, llega acompañado.',
  'Con buen equipo, hasta el día flojo se levanta.',
  'Ayudar no te resta; te hace indispensable.',

  // — Actitud / mentalidad —
  'Tu día lo decides tú, no el clima ni el tráfico.',
  'Cambia el “tengo que” por “voy a” y todo pesa menos.',
  'Enfócate en lo que sí puedes controlar.',
  'Un problema es una venta disfrazada de reto.',
  'Respira, sonríe y vuelve a marcar.',
  'La queja no vende; la solución sí.',
  'Piensa en soluciones y el cansancio se aparta.',
  'Empieza fuerte: el primer sí anima todo el día.',
  'Lo que agradeces, se multiplica.',
  'Tu mente es tu primera oficina; tenla en orden.',
  'Cada mañana es una hoja nueva para tu récord.',
  'No cargues el error de ayer al cliente de hoy.',
  'La paciencia es músculo; entrénala.',
  'Confía en tu preparación y suéltate.',
  'El buen humor es una decisión, no una suerte.',
  'Aprende del “no” y sigue caminando.',
  'Menos prisa, más presencia.',
  'Ponle intención a la primera hora del día.',
  'Tu enfoque decide tu resultado.',
  'Habla contigo como le hablarías a alguien que quieres.',
  'La calma vende, la ansiedad ahuyenta.',
  'Hoy elige avanzar, aunque sea un paso.',
  'Lo que crees de ti, se te nota al vender.',
  'Cambia el chip: cada llamada es una nueva chance.',
  'La actitud abre puertas que el talento no alcanza.',
  'Sé constante en lo pequeño y firme en lo importante.',
  'Tu mejor herramienta hoy es tu ánimo.',
  'Empieza con calma, termina con orgullo.',

  // — Cancún / playa (más) —
  'Ponle sabor a Caribe a cada saludo.',
  'Como la marea, vuelve siempre a intentarlo.',
  'El sol sale para todos; aprovéchalo tú primero.',
  'Trabaja fresco como brisa y firme como palmera.',
  'Regala paraíso con cada palabra.',
  'La playa espera; tú haz que lleguen a ella.',
  'Con paciencia de mar, todo folio llega a buen puerto.',
  'Que tu ánimo brille como mediodía en Cancún.',
  'Cada venta es un boleto a la felicidad de alguien.',
  'Rema parejo aunque cambie el viento.',
  'Lleva calma de playa a los días de tormenta.',
  'El Caribe se vende mejor con una sonrisa.',
  'Sé constante como la ola que no se rinde.',
  'Hoy repartes sol; que se te note.',
  'La arena guarda cada paso; deja buenos.',
  'Como el faro, mantén tu luz aunque anochezca.',
  'Ponle ritmo caribeño al día y rendirás más.',
  'El mar premia a quien insiste en remar.',
  'Tu energía de playa alegra hasta al cliente difícil.',
  'Vende el paraíso creyendo que tú vives en él.',
];

// Bloque 14: mensajes del popup de bienvenida (comunicacion interna/MENSAJES_BIENVENIDA.md).
// Formato "frase — Autor"; Marco puede quitar o agregar aquí.
export const MENSAJES_BIENVENIDA = [
  "O tú diriges el día, o el día te dirige a ti. — Jim Rohn",
  "No desees que fuera más fácil, desea ser mejor. — Jim Rohn",
  "La disciplina es el puente entre las metas y los logros. — Jim Rohn",
  "El éxito no es más que unas cuantas disciplinas sencillas practicadas todos los días. — Jim Rohn",
  "Trabaja más en ti mismo que en tu trabajo. — Jim Rohn",
  "La motivación te pone en marcha; el hábito te mantiene en marcha. — Jim Rohn",
  "No eres pagado por la hora, eres pagado por el valor que le das a la hora. — Jim Rohn",
  "Si de verdad quieres algo, encontrarás la manera; si no, encontrarás una excusa. — Jim Rohn",
  "Establecer metas es el primer paso para convertir lo invisible en visible. — Tony Robbins",
  "El camino al éxito es tomar acción masiva y decidida. — Tony Robbins",
  "La calidad de tu vida es la calidad de tus preguntas. — Tony Robbins",
  "Donde pones tu atención, pones tu energía. — Tony Robbins",
  "No se trata de recursos, se trata de ser ingenioso. — Tony Robbins",
  "Es en tus momentos de decisión cuando se forma tu destino. — Tony Robbins",
  "Mantente positivo, alegre y orientado a objetivos. El éxito en ventas es 80 % actitud y 20 % aptitud. — Brian Tracy",
  "Las metas te permiten controlar la dirección del cambio a tu favor. — Brian Tracy",
  "Cada minuto que inviertes en planear te ahorra diez en la ejecución. — Brian Tracy",
  "Trata a cada cliente como el más importante del día. — Brian Tracy",
  "La gente no compra productos, compra soluciones y buenos sentimientos. — Brian Tracy",
  "Cómete ese sapo: haz primero lo más difícil del día. — Brian Tracy",
  "Nunca digas algo de ti mismo que no quieras que sea verdad. — Brian Tracy",
  "Tu éxito en ventas depende de las preguntas que hagas y de cuánto escuches. — Brian Tracy",
];

// ── Bloque 14: bienvenida esporádica y al azar ──
// - Nunca más de 1 cada 2 días por usuario.
// - Ya pasados los 2 días, sale con probabilidad 40%; si no sale, se reintenta en el siguiente inicio.
// - Nunca el primer día del agente: si su alta (created_at) es de hace menos de 24 h, o si es la primera vez
//   que entra en este equipo, solo se anota la fecha y no sale.
// - Mensaje al azar sin repetir el último. Se guarda en localStorage; si falla, no se muestra.
export const BIENVENIDA_CADA_MS = 2 * 24 * 3600 * 1000;
export const BIENVENIDA_PROB = 0.4;
export const decidirBienvenida = (ag, ahora = Date.now(), azar = Math.random) => {
  try {
    if (!ag || ag.id == null || !MENSAJES_BIENVENIDA.length) return null;
    const key = `c100-bienvenida-${ag.id}`;
    const raw = localStorage.getItem(key);
    const st = raw ? JSON.parse(raw) : null;
    const alta = ag.created_at ? new Date(ag.created_at).getTime() : NaN;
    if (!st) { localStorage.setItem(key, JSON.stringify({ ultima: ahora, idx: -1 })); return null; }
    if (!Number.isNaN(alta) && ahora - alta < 24 * 3600 * 1000) return null;
    if (!(ahora - Number(st.ultima || 0) >= BIENVENIDA_CADA_MS)) return null;
    if (azar() >= BIENVENIDA_PROB) return null;
    const n = MENSAJES_BIENVENIDA.length;
    let idx = Math.floor(azar() * n) % n;
    if (n > 1 && idx === st.idx) idx = (idx + 1) % n;
    localStorage.setItem(key, JSON.stringify({ ultima: ahora, idx }));
    const m = MENSAJES_BIENVENIDA[idx];
    return typeof m === 'string' ? m : (m && (m.frase || m.texto)) || null;
  } catch { return null; }
};

export default FRASES_MOTIVACIONALES;
